import React, { useState, useEffect } from "react";
import { Card, CardContent } from "./ui/card";
import { discourseService, DiscourseUser } from "../services/discourseService";
import { MessageSquare, Award, Star } from "lucide-react";

const YourActivitySection: React.FC = () => {
  const [user, setUser] = useState<DiscourseUser | null>(null);
  const [userStats, setUserStats] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get current user first
        const userData = await discourseService.getCurrentUser();
        setUser(userData);
        
        if (userData) {
          // Get user statistics
          const stats = await discourseService.getUserStats(userData.username);
          setUserStats(stats);
        }
      } catch (error) {
        console.error('Failed to fetch activity data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Helper function to format numbers with fallback
  const formatNumber = (value: number | undefined, fallback: string = "0") => {
    if (value === undefined || value === null) return fallback;
    return value.toString();
  };

  return (
    <div className="px-6 py-6">
      <Card className="bg-slate-800 rounded-xl">
        <CardContent className="p-6">
          <h3 className="text-xl font-semibold text-white mb-6">
            Your Activity
          </h3>
          
          {isLoading ? (
            <div className="grid grid-cols-3 gap-6">
              {[1, 2, 3].map((i) => (
                <div key={i} className="text-center">
                  <div className="h-8 bg-slate-700 rounded animate-pulse mb-2"></div>
                  <div className="h-4 bg-slate-700 rounded animate-pulse"></div>
                </div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-3 gap-6">
              {/* Forum Posts */}
              <div className="text-center">
                <div className="text-2xl font-bold text-command-light-blue mb-1 flex items-center justify-center">
                  <MessageSquare className="h-5 w-5 mr-2" />
                  {formatNumber(userStats?.post_count, "0")}
                </div>
                <div className="text-white/50 text-xs">Forum Posts</div>
              </div>
              
              {/* Solutions (using topics as a proxy) */}
              <div className="text-center">
                <div className="text-2xl font-bold text-command-green mb-1 flex items-center justify-center">
                  <Award className="h-5 w-5 mr-2" />
                  {formatNumber(userStats?.topic_count, "0")}
                </div>
                <div className="text-white/50 text-xs">Solutions</div>
              </div>
              
              {/* Badges (using trust level as a proxy) */}
              <div className="text-center">
                <div className="text-2xl font-bold text-purple-400 mb-1 flex items-center justify-center">
                  <Star className="h-5 w-5 mr-2" />
                  {formatNumber(user?.trust_level, "0")}
                </div>
                <div className="text-white/50 text-xs">Badges</div>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default YourActivitySection;
